import { useEffect, useRef, useState } from "react";

export default function OtpInput({ length = 6, value, onChange, autoFocus = true, "data-testid": testId }) {
  const refs = useRef([]);
  const [digits, setDigits] = useState(() => Array.from({ length }, (_, i) => value?.[i] || ""));

  useEffect(() => {
    setDigits(Array.from({ length }, (_, i) => value?.[i] || ""));
  }, [value, length]);

  useEffect(() => {
    if (autoFocus && refs.current[0]) refs.current[0].focus();
  }, [autoFocus]);

  const update = (next) => {
    setDigits(next);
    onChange?.(next.join(""));
  };

  const handleChange = (idx, raw) => {
    const v = raw.replace(/\D/g, "").slice(-1);
    const next = [...digits];
    next[idx] = v;
    update(next);
    if (v && idx < length - 1) refs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !digits[idx] && idx > 0) {
      refs.current[idx - 1]?.focus();
    }
    if (e.key === "ArrowLeft" && idx > 0) refs.current[idx - 1]?.focus();
    if (e.key === "ArrowRight" && idx < length - 1) refs.current[idx + 1]?.focus();
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    if (!text) return;
    e.preventDefault();
    const next = Array.from({ length }, (_, i) => text[i] || "");
    update(next);
    refs.current[Math.min(text.length, length - 1)]?.focus();
  };

  return (
    <div className="flex gap-2.5 items-center justify-center" data-testid={testId}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          value={d}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          inputMode="numeric"
          maxLength={1}
          className="otp-cell"
          aria-label={`Digit ${i + 1}`}
          data-testid={`${testId || "otp"}-cell-${i}`}
        />
      ))}
    </div>
  );
}
